import { MRT_ColumnDef } from 'material-react-table';
import { ModalData, ScenarioData } from '../types';
import i18next from 'i18next';

export const PricingScenarioModalData = (
  headers: MRT_ColumnDef<ScenarioData>[],
  rows: ScenarioData[]
): ModalData[] => {
  const modelData: ModalData[] = [];
  const mainHeader =
    i18next.language === 'fr'
      ? ['Résumé des primes et taxes', 'Calcul de la prime et résumé des impôts']
      : ['Premium and Tax Summary', 'Premium Calculation and Tax Summary'];
  const subKey = 'calculateTotal';
  const skipKey = 'Total';

  headers.forEach((col) => {
    if (!col) return;

    if (!Array.isArray(headers) || !Array.isArray(rows)) return modelData;

    const rowsCopy: ScenarioData[] = structuredClone(rows);

    const premiumSection = rowsCopy.find(
      (s) => s.rowHeader.includes(mainHeader[0]) || s.rowHeader.includes(mainHeader[1])
    );

    const totalRow = premiumSection?.subRows?.find((r) => r.key === subKey);

    if (!totalRow || totalRow[col?.accessorKey ?? ''] === skipKey) return;

    modelData.push({
      RowName: String(col.header ?? ''),
      RowAmount: totalRow[col?.accessorKey ?? '']?.toString()
    });
  });

  return modelData;
};
